import { observable, action, makeObservable } from "mobx";
import * as _ from "lodash";
import { ErrorMsg } from "../types/ErrorMsg";

export class ErrorStore {
    errors: Error[] = [];

    constructor() {
        makeObservable(this, {
            errors: observable,
            addError: action,
            addBasicError: action,
            removeError: action,
        });
    }

    async addError(resp: Response | ErrorMsg | undefined | Error | Blob) {
        if (!resp) {
            return;
        }

        console.log(resp);
        if (resp instanceof Error) {
            this.errors.push(new Error(JSON.stringify(resp)));
        } else if (resp instanceof Blob) {
            if (resp.type?.includes("application/json")) {
                const msg = <ErrorMsg>JSON.parse(await resp.text());
                if (typeof msg.title === "object" && msg.title.errors) {
                    const errorMessage =
                        msg.title.errors[0]?.message || "Unknown error";
                    const error = new Error(errorMessage);
                    this.errors.push(error);
                    console.error(error.message);
                } else {
                    const error = new Error(msg.title);
                    this.errors.push(error);
                    console.error(error.message);
                }
            } else {
                this.errors.push(new Error(JSON.stringify(resp)));
            }
        } else if (!(resp instanceof Response) && resp.title) {
            let error;
            if (typeof resp.title === "object" && resp.title.errors) {
                const errorMessage =
                    resp.title.errors[0]?.message || "Unknown error";
                error = new Error(errorMessage);
                this.errors.push(error);
                console.error(error.message);
            } else {
                error = new Error(resp.title);
                this.errors.push(error);
                console.error(error.message);
            }
        } else if (
            resp instanceof Response &&
            resp.headers &&
            resp.headers.get("Content-Type") === "application/json"
        ) {
            const msg = <ErrorMsg>await resp.json();
            if (typeof msg.title === "object" && msg.title.errors) {
                const errorMessage =
                    msg.title.errors[0]?.message || "Unknown error";
                const error = new Error(errorMessage);
                this.errors.push(error);
                console.error(error.message);
            } else {
                const error = new Error(msg.title);
                this.errors.push(error);
                console.error(error.message);
            }
        } else {
            this.errors.push(new Error(JSON.stringify(resp)));
        }
    }

    async addBasicError(error: Error) {
        this.errors.push(error);
        console.error(error.message);
    }

    removeError(error: Error) {
        _.remove(this.errors, function (n: Error) {
            return _.isEqual(error, n);
        });
    }
}

export default ErrorStore;
